import { baseAppPath } from './appurl'
import { sharingToken } from './sharingtoken'
import { synoTokenFromSessionStorage } from './synotoken'

export const objectToSearchParams = (params) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach((kv) => {
    if (Array.isArray(kv[1])) {
      searchParams.append(kv[0], JSON.stringify(kv[1]))
    } else if (typeof kv[1] === 'object') {
      searchParams.append(kv[0], objectToSearchParams(kv[1]))
    } else {
      searchParams.append(kv[0], kv[1])
    }
  })

  return searchParams
}

const webapiURL = (params) => {
  const cgiPath = '/webapi/entry.cgi'

  const searchParams = objectToSearchParams(params)

  const sharingtoken = sharingToken()

  if (sharingtoken) {
    searchParams.append('sharing_token', sharingtoken)
  }

  const synotoken = synoTokenFromSessionStorage()

  if (synotoken) {
    searchParams.append('SynoToken', synotoken)
  }

  return `${baseAppPath()}${cgiPath}?${searchParams.toString()}`
}

export default webapiURL
